import Avatar from './Avatar'
export {
    AvatarGroup
} from './AvatarGroup'

export {
    UserAvatar
}
    from './UserAvatar'
export default Avatar